const mainRoles = ["super-admin", "call-center-admin", "call-center-supervisor", "call-center-manager"];
const agentRoles = [...mainRoles, "call-center-agent", "senior-call-center-sales-agent"];
const arRoles = [...mainRoles, "call-center-ar-agent"];
const documentRoles = [...mainRoles, "call-center-document-manager"];
const alertSettingsRoles = [...mainRoles, "senior-call-center-sales-agent"];

export default [
  {
    id: "sales-dashboard-menu-item",
    type: "item",
    component: "navigation-drawer-item",
    icon: "home",
    title: "Sales Dashboard",
    route_to: "/",
    roles: agentRoles
  },
  {
    id: "attach-money-menu-item",
    type: "item",
    component: "navigation-drawer-item",
    icon: "attach_money",
    title: "A/R Dashboard",
    route_to: "arDashboard",
    roles: arRoles
  },
  {
    id: "users-list-menu",
    type: "list",
    component: "navigation-drawer-list",
    icon: "web",
    title: "Users",
    roles: mainRoles.filter(roles => roles !== "call-center-supervisor"),
    items: [
      {
        id: "users-list-manage-users",
        type: "item",
        component: "navigation-drawer-item",
        icon: "",
        title: "Manage Users",
        route_to: "usersIndex",
        roles: mainRoles
      }
    ]
  },
  {
    id: "settings-list-menu",
    type: "list",
    component: "navigation-drawer-list",
    icon: "settings",
    title: "Settings",
    roles: mainRoles,
    items: [
      {
        id: "settings-general-menu-item",
        type: "item",
        component: "navigation-drawer-item",
        icon: "format_list_bulleted",
        title: "General",
        route_to: "appSettings",
        roles: mainRoles
      },
      {
        id: "settings-facilities-menu-item",
        type: "item",
        component: "navigation-drawer-item",
        icon: "business",
        title: "Facilities",
        route_to: "adminFacilitiesIndex",
        roles: mainRoles
      },
      {
        id: "settings-dispositions-menu-item",
        type: "item",
        component: "navigation-drawer-item",
        icon: "settings_phone",
        title: "Dispositions",
        route_to: "dispositionsIndex",
        roles: mainRoles
      }
    ]
  },
  {
    id: "settings-alerts-menu-item",
    type: "item",
    component: "navigation-drawer-item",
    icon: "warning",
    title: "Alerts",
    route_to: "alertsIndex",
    roles: alertSettingsRoles
  },
  {
    id: "call-list-menu-item",
    type: "item",
    component: "navigation-drawer-item",
    icon: "contact_phone",
    title: "Call List",
    route_to: "callList",
    roles: mainRoles
  },
  {
    id: "reporting-list-menu",
    type: "list",
    component: "navigation-drawer-list",
    icon: "receipt",
    title: "Reporting",
    roles: mainRoles,
    items: [
      {
        id: "reporting-effective-rate-menu-item",
        type: "item",
        component: "navigation-drawer-item",
        icon: "",
        title: "Effective Rate",
        route_to: "effectiveRateIndex",
        roles: mainRoles
      },
      {
        id: "reporting-audit-approval-menu-item",
        type: "item",
        component: "navigation-drawer-item",
        icon: "",
        title: "Audit Approval",
        route_to: "auditApprovalIndex",
        roles: mainRoles.filter(role => role !== "call-center-supervisor")
      },
      {
        id: "reporting-gift-cards-menu-item",
        type: "item",
        component: "navigation-drawer-item",
        icon: "",
        title: "Gift Cards",
        route_to: "giftCard",
        roles: mainRoles
      }
    ]
  },
  {
    id: "document-manager-menu-item",
    type: "item",
    component: "navigation-drawer-item",
    icon: "folder_open",
    title: "Document Manager",
    route_to: "documentManager",
    roles: documentRoles
  }
];
